import script from "./LiteVersionPreferences.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteVersionPreferences.vue?vue&type=script&setup=true&lang=js"

import "./LiteVersionPreferences.vue?vue&type=style&index=0&id=6d25e0fb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d25e0fb"]])

export default __exports__